import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="select"
export default class extends Controller {
  connect() {
    new TomSelect("#product_row_material_row_material_id",{
      sortField: {
        field: "text",
        direction: "asc"
      },
      maxOptions: null
    });
    setTimeout(() => {
      document.getElementById("product_row_material_row_material_id").tomselect.close() 
    }, 100);
  }
}
